export default {
    Providers: '/providers',
    Dashboard: '/dashboard',
    Students: '/students',
    Orders: '/orders/list',
    /*  CALENDAR: '/calendar',
    CASES: '/cases',
    ORDERS: '/orders',
    SESSIONS: '/seances',
    PAYMENTS: '/payments',
    CREDITS: '/credits',
    INVOICES: '/invoices',
    PAYROLLS: '/payrolls',
    'PAYROLL REPORTS': '/reports',
    EXPENSES: '/expenses',
    INTERNALS: '/internals',
    'ADMIN WORK': '/admin-work',
    DEDUCTIONS: '/deductions',
    VENDORS: '/vendors',
    DISTRICTS: '/districts',
    STUDENTS: '/students',
    'SERVICE TYPES': '/service-types',
    'SERVICE LOCATIONS': '/service-locations',
    'AGENCY INFO': '/agency-info',
    'EMAILS LOG': '/emails-log',*/
};
